export const UNITAG_VALID_REGEX = /^[a-z0-9]+$/
export const UNITAG_SUFFIX = '.uni.eth'
export const UNITAG_SUBDOMAIN = '.uni'
export const UNITAG_SUFFIX_NO_LEADING_DOT = UNITAG_SUFFIX.substring(1)
export const AVATAR_UPLOAD_CREDS_EXPIRY_SECONDS = 120
